import * as React from 'react'
import Sidebar from 'react-sidebar'
import { MdClientSelect, MdProductSelect, MdHubSelect, MdTabs, MdDropdown } from '../widgets'
import * as _ from 'lodash'
import { MdTableContainer } from './MdTableContainer'
import {
  getBalancesForEwarrant,
  getCreatedEwarrants,
  getCertifiedEwarrants,
  getCancelledEwarrants,
  getAvailableVaultItems,
  getContractIdsWithEwarrantHistory,
  getBaseContracts
} from '../../api/ewarrants'
import EvwSidePanel from '../presentations/EvwSidePanel'
const moment = require('moment')

export class EvwContainer extends React.Component<any, MdTableContainerState & EvwTableState> {
  constructor (props: any) {
    super(props)
    let baseContracts = getBaseContracts()
    let contractIds = baseContracts.map(contract => contract.id)

    this.state = {
      baseContracts: baseContracts,
      dataset: [],
      accounts: this.getAllAccounts(),
      availableVaultItems: [],
      contractIds: contractIds,
      contractIdsWithEvwHistory: [],
      productFilterContractIds: contractIds,
      hubFilterContractIds: contractIds,
      datasetHeaders: this.getInitialHeaders('Available'),
      statuses: ['Available', 'Created', 'Certified', 'Cancelled'],
      activeStatus: 'Available',
      sortBy: ['hin', 'asc'],
      limit: 15,
      page: 1,
      totalPages: 0,
      pageStep: 2,
      showPanel: false,
      selectedRow: null,
      sidebarOpen: false
    }

    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
  }

  public async componentDidMount () {
    const marketplaceId = window['md3'].marketplace.filter({
      where: {
        'metaldesk.active': true
      }
    })[0].id

    const ids = (await getContractIdsWithEwarrantHistory(marketplaceId)).data.data
    this.setState({contractIdsWithEvwHistory: ids})
  }

  public getAllAccounts() {
    return window['md3'].account.filter({})
  }

  public getActiveAccount() {
    return window['md3'].account.filter({
      where: {
      'metaldesk.active': {
          '==': true
        }
      }
    })[0]
  }

  public onSetSidebarOpen(open) {
    this.setState({
      sidebarOpen: open
    })
  }

  public componentWillMount() {
    this.getNewDataset()
  }

  public getInitialHeaders(activeStatus) {
    let datasetHeaders = {
      'Available': [
        { key: 'hin' }, { key: 'accountName' }, { key: 'hubName' }, { key: 'productName' },
        { key: 'availableForEvw' }, { key: 'evwInProgress' }
      ],
      'Created': [
        { key: 'hin' }, { key: 'accountName', width:'250px' }, { key: 'hubName' }, { key: 'productName' },
        { key: 'requesterName', width:'250px'  }, { key: 'createdAt', namedKey: 'evwCreatedAt' }, { key: 'serialNumber' }, { key: 'hallmark' }
      ],
      'Certified': [
        { key: 'hin' }, { key: 'accountName', width:'220px' }, { key: 'hubName' }, { key: 'productName' },
        { key: 'requesterName', width:'220px' }, { key: 'createdAt', namedKey: 'evwCreatedAt' }, { key: 'updatedAt', namedKey: 'certifiedAt' },
        { key: 'serialNumber' }, { key: 'hallmark' }, { key: 'warrantNumber' }
      ],
      'Cancelled': [
        { key: 'hin' }, { key: 'accountName', width:'250px' }, { key: 'hubName' }, { key: 'productName' },
        { key: 'requesterName', width:'250px' }, { key: 'createdAt', namedKey: 'evwCreatedAt' }, { key: 'updatedAt', namedKey: 'cancelledAt' },
        { key: 'serialNumber' }, { key: 'hallmark' }, { key: 'warrantNumber' }
      ]
    }
    return datasetHeaders[activeStatus]
  }

  public getSortedDatasetHeaders(id, sortByCol) {
    return Object.assign([], this.getInitialHeaders(this.state.activeStatus), { [id] : sortByCol })
  }

  private determineContractIds(hubFilterContracts: number[], productFilterContracts: number[]): number[] {
    return _.intersection( hubFilterContracts, productFilterContracts ) as number[]
  }

  public clearSelectedRow() {
    this.setState({
      selectedRow: null,
      sidebarOpen: false
    })
  }

  public async getNewDataset() {
    let activeStatus = this.state.activeStatus
    let contractIds = this.state.contractIds.length > 0 ? this.state.contractIds : null
    let dataQuery = {
      'Available': getBalancesForEwarrant,
      'Created': getCreatedEwarrants,
      'Certified': getCertifiedEwarrants,
      'Cancelled': getCancelledEwarrants
    }
    let accountIds = this.state.accounts.map(account => account.id)
    const rawData: any = (await dataQuery[activeStatus](
      contractIds, this.state.limit, this.state.limit * (this.state.page - 1), accountIds.length === 1 ? accountIds : undefined
    )).data
    const count = rawData.meta.count
    let totalPages = Math.ceil(count / this.state.limit)

    let formattedData = _.map(rawData.data, (data: any) => {
      if (data.createdAt) { data.createdAt = moment(data.createdAt).format('YYYY/MM/DD HH:mm')}
      if (data.updatedAt) { data.updatedAt = moment(data.updatedAt).format('YYYY/MM/DD HH:mm')}
      if (data.productName) {
        data.productName = (<div style={{'line-height': 'inherit', 'padding-left': '0px'}} className='product-name'>
                              <span className={_.toLower(data.metalName) + '-legend'}></span>{data.productName}
                            </div>)
      }
      return data
    })

    let newRow = this.state.selectedRow ? formattedData[this.state.selectedRow.key] : null
    if (newRow) { newRow.key = this.state.selectedRow.key }

    this.setState({
      datasetHeaders: this.getInitialHeaders(activeStatus),
      dataset: formattedData,
      totalPages: totalPages,
      selectedRow: newRow,
      contractIds: contractIds
    })
  }

  public render() {
    let tableContainerCss: any = {height: '100%'}
    if (this.state.showPanel) {
      tableContainerCss.marginRight = '300px'
    }
    return (
      <div>
        <Sidebar
          sidebar={
                <EvwSidePanel
                clearSelectedRow={() => this.clearSelectedRow()}
                selectedRow={this.state.selectedRow}
                availableVaultItems={this.state.availableVaultItems}
                activeStatus={this.state.activeStatus}
                closePanel={() => {
                  this.setState({
                    sidebarOpen: false,
                    selectedRow: null
                  })
                }}
                updateDataset={() => this.getNewDataset()}
                />}
          styles={
            {
              sidebar: {
                width: '350px',
                top: '40px',
                borderLeft: '2px solid #222222',
                padding: '10px'
              },
              content: {
                top: '70px',
                left: '100px',
                overflowY: 'none'
              }
            }
          }
          open={this.state.sidebarOpen}
          onSetOpen={this.onSetSidebarOpen}
          docked={this.state.sidebarOpen}
          pullRight={true}>
          <header className='report-toolbar'>
            <div style={{display: 'inline-block'}}>
              <MdClientSelect
                hideHouse={
                  this.getActiveAccount().categoryId === AccountCategories.centralClearingParty ||
                  this.getActiveAccount().categoryId === AccountCategories.introducingBroker ?
                  true : false
                }
                hideIbs={true}
                onAccountChange={(account) => {
                  let accountsList
                  if (account) {
                    accountsList = [account]
                  } else {
                    accountsList = this.getAllAccounts()
                  }
                  this.setState({
                      accounts: accountsList,
                      page: 1,
                      selectedRow: null,
                      sidebarOpen: false
                    }, () => {
                      this.getNewDataset()
                    })
                  }
                } />
            </div>
            <div style={{display: 'inline-block', width:'300px'}}>
              <MdHubSelect
                baseContracts={this.state.baseContracts}
                onHubChange={(hubs: any[]) => {
                  let hubContractIds = _.flatMap(hubs, (hub) => {
                    return hub.contracts.map((contract) => contract.id)
                  })
                  let contractIds = this.determineContractIds(hubContractIds, this.state.productFilterContractIds)
                  this.setState({
                    contractIds: contractIds,
                    hubFilterContractIds: hubContractIds,
                    page: 1,
                    selectedRow: null,
                    sidebarOpen: false
                  }, () => this.getNewDataset() )
                }} />
            </div>
            <div style={{display: 'inline-block'}}>
              <MdProductSelect
                baseContracts={this.state.baseContracts}
                onSelectUpdate={(data: any) => {
                  let productContractIds = data.contracts
                  let contractIds = this.determineContractIds(this.state.hubFilterContractIds, productContractIds)
                  this.setState({
                    contractIds: contractIds,
                    productFilterContractIds: productContractIds,
                    page: 1,
                    selectedRow: null,
                    sidebarOpen: false
                  }, () => this.getNewDataset() )
                }} />
            </div>
            <div style={{display: 'inline-block', width: '380px'}}>
              <MdTabs tabs={
                _.map(this.state.statuses, (status) => {
                  return {
                    content: status as string,
                    handleClick: () => {
                      let baseContracts = getBaseContracts()
                      let contractIds = baseContracts.map(c => c.id)

                      if (status !== 'Available') {
                        const unionContractIds = _.union(contractIds, this.state.contractIdsWithEvwHistory)
                        baseContracts = window['md3'].contract.filter({
                          where: {
                            id: { in: unionContractIds }
                          }
                        })
                        contractIds = baseContracts.map(c => c.id)
                      }

                      this.setState({
                        activeStatus: status,
                        page: 1,
                        selectedRow: null,
                        sidebarOpen: false,
                        baseContracts: baseContracts,
                        contractIds: contractIds,
                        productFilterContractIds: contractIds,
                        hubFilterContractIds: contractIds
                      }, () => this.getNewDataset())
                    }
                  }
                })}
                activeTab={this.state.activeStatus} tabStyle={{width: '380px'}}
                />
            </div>
            <div style={{display: 'inline-block', marginLeft: '15px'}}>
              <MdDropdown
                options={[
                  {
                    title: 'Export to CSV',
                    logic: () => {
                      let accountIds = ''
                      if (this.state.accounts.length === 1) {
                        accountIds = 'accountId=' + _.head(this.state.accounts.map(a => a.id)) + '&'
                      }
                      let contractIds = 'contractId=' + this.state.contractIds.join(',')

                      let csvUrl = {
                        'Available' : `/md3api/balances/ewarrants.csv?${accountIds}${contractIds}`,
                        'Created': `/md3api/ewarrantscsv/created?${accountIds}${contractIds}`,
                        'Certified': `/md3api/ewarrantscsv/certified?${accountIds}${contractIds}`,
                        'Cancelled': `/md3api/ewarrantscsv/cancelled?${accountIds}${contractIds}`
                      }
                      window.open(csvUrl[this.state.activeStatus])
                    }
                  }
                ]}
              />
            </div>

          </header>
          <div style={tableContainerCss}>
            <MdTableContainer
              dataset={this.state.dataset}
              datasetHeaders={this.state.datasetHeaders}
              totalPages={this.state.totalPages}
              page={this.state.page}
              pageStep={this.state.pageStep}
              onSort={(id, sortBy) => {
                  this.setState({
                    selectedRow: null,
                    sidebarOpen: false,
                    sortBy: [sortBy.key, sortBy.sorted],
                    datasetHeaders: this.getSortedDatasetHeaders(id, sortBy)
                  }, () => this.getNewDataset())
                }
              }
              selectedRow={this.state.selectedRow ? this.state.selectedRow.key : null}
              onSelectRow={async (selectedRow) => {
                let availableVaultItems = []
                if (selectedRow.status === EwarrantStatus.created || selectedRow.status === EwarrantStatus.segregated) {
                  availableVaultItems = (await getAvailableVaultItems(selectedRow.contractId)).data.data[selectedRow.contractId]
                }

                this.setState({
                  sidebarOpen: this.state.activeStatus !== 'Cancelled' ? true : false,
                  selectedRow: selectedRow,
                  availableVaultItems
                })
              }}
              onChangePage={(pageNum) => {
                this.setState({
                  selectedRow: null,
                  sidebarOpen: false,
                  page: pageNum
                }, () => this.getNewDataset())
              }}
            />
          </div>
        </Sidebar>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./react/components/containers/EvwContainer.tsx